import React from "react";
import { Link } from "react-router-dom";
import { LEGAL_STAND_ANZEIGE } from "../config/legal";

const Agb = () => {
  return (
    <div className="myn-legal">
      <div className="myn-card">
        <h1 className="myn-h2">Allgemeine Geschäftsbedingungen</h1>
        <div className="myn-prose">
          <p className="text-muted small">Stand: {LEGAL_STAND_ANZEIGE}</p>
          <p>
            Diese Bedingungen gelten für den kostenlosen Test-QR-Code und für die
            Selbstbuchung eines digitalen QR-Codes auf MYN.CLUB. Vertragspartner ist
            das Unternehmen, das auf der Angebotsseite als Vertragspartner genannt
            wird. Betreiber der Plattform ist die EDEL Investment GmbH,
            Marienburger Str. 2D, 40789 Monheim am Rhein.
          </p>

          <h2>1. Ablauf</h2>
          <p>
            Sie können auf der Startseite ein Unternehmen suchen und einen QR-Code
            probeweise erzeugen. Ein kostenpflichtiger Vertrag entsteht erst, wenn
            Sie ein Angebot auswählen, diese Bedingungen sowie die angezeigten
            Preis- und Tarifkonditionen akzeptieren und die Buchung absenden.
          </p>

          <h2>1a. Kostenloser Test-QR-Code</h2>
          <p>
            Der Test-QR-Code ist kostenlos und erfordert keine Registrierung. Er wird
            für einen begrenzten Testzeitraum an das von Ihnen gewählte Unternehmen
            gebunden; danach wird er automatisch wieder freigegeben. Der Code trägt
            ein MYN.CLUB-Wasserzeichen. Sie dürfen ihn herunterladen und über die
            angebotenen Wege (z. B. WhatsApp, Facebook, Instagram, TikTok) teilen.
          </p>
          <p>
            Mit dem Erzeugen bestätigen Sie, dass Sie für das gewählte Unternehmen
            handeln dürfen, und Sie akzeptieren diese Bedingungen sowie die{" "}
            <Link to="/datenschutz">Datenschutzerklärung</Link>. Sie stimmen zu, dass
            Firmenname und Adresse des Unternehmens für die Dauer des Tests öffentlich
            im Bereich „Gerade erzeugt“ auf der Startseite angezeigt werden. Ein
            Anspruch auf dauerhafte Bereitstellung des Test-Codes besteht nicht.
          </p>

          <h2>2. Konto</h2>
          <p>
            Für die Buchung genügen E-Mail-Adresse und Passwort. Die E-Mail-Adresse
            muss bestätigt werden, bevor eine Anmeldung möglich ist. Firmierung,
            Anschrift und Ansprechpartner ergänzen Sie nach der Anmeldung in Ihrem
            Konto. Der zuvor erzeugte QR-Code wird diesem Konto zugeordnet.
          </p>

          <h2>3. Preis</h2>
          <p>
            Es gelten die Preise des gewählten Angebots, wie sie vor dem Absenden
            angezeigt werden: der Nettobetrag der genannten Abrechnungsperiode,
            eine gegebenenfalls ausgewiesene einmalige Aktivierungsgebühr und die
            gesetzliche Steuer. Die Rechnung finden Sie nach der Anmeldung unter
            „Meine Rechnungen“.
          </p>

          <h2>4. Leistung</h2>
          <p>
            Sie erhalten einen digitalen QR-Code für den im Angebot genannten Dienst.
            Welches Ziel der QR-Code öffnet, ergibt sich aus dem jeweiligen Dienst
            und wird im Angebot genannt. Sie können den Code in Ihrem Konto
            herunterladen und über die angebotenen Wege teilen. Die
            Standortkennung Ihres Unternehmens wird nur intern verwendet und nicht
            angezeigt.
          </p>

          <h2>5. Pflichten</h2>
          <p>
            Sie buchen nur für ein Unternehmen, für das Sie handeln dürfen. Zugangsdaten
            halten Sie geheim. Hinweise zum Datenschutz stehen in der{" "}
            <Link to="/datenschutz">Datenschutzerklärung</Link>.
          </p>

          <h2>6. Laufzeit</h2>
          <p>
            Laufzeit, Kündigung und weitere Tarifdetails ergeben sich aus dem
            gewählten Tarif und werden vor der Buchung angezeigt. Gesetzliche
            Rechte bleiben unberührt.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Agb;
